import { RouteLocationNormalized, Router } from 'vue-router';
import { loginRequest, msalInstance } from '@/authenticationConfig';
import { AUTHENTICATION } from '@/store/mutation-types';
import StringUtils from '@/common/utils/StringUtils';
import { store } from '@/plugins/store';
import { AuthenticationResult } from '@azure/msal-browser';
import { AuthAction } from '@/modules/Auth/store/actions-types';
import { AuthenticationParameters } from '@/modules/Auth/store/state';
import { HomeAction } from '@/modules/Home/store/actions-types';

export function registerGuard(router: Router): void {
    // Avant chaque route
    router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
        // Redirection si une route hash (ex: #/validation-devis?token=...) est passée dans l'URL
        if (to.hash && to.hash.startsWith('#/')) {
            const hashRoute = to.hash.substring(1);
            return hashRoute;
        }

        // On enregistre la route sur laquelle on était
        localStorage.setItem('previousRoute', from.path.toString() || '');
        localStorage.setItem('nextRoute', to.path?.toString() || '');

        // Si on a défini la route comme nécessitant d'être authentifié
        if (to.meta.requiresAuth) {
            // Utilisé seulement en WEB après la saisie valide du login/pwd dans Azure
            if (from.path === '/' && to.path === '/dashboard' && to.hash && !to.hash.startsWith('#error')) {
                await msalInstance.handleRedirectPromise();
            }
            // On vérifie si la personne est connectée
            const authenticated = await isAuthenticated();

            store.commit(`authenticationState/${AUTHENTICATION.SET_SIGN_IN_AZURE_SUCCESSFUL}`, authenticated);

            handleAzureError(authenticated, to, from);

            if (from.path === '/') {
                await store.dispatch(HomeAction.SHOW_HOMEPAGE_MODAL);
            }

            if (!authenticated) {
                localStorage.setItem('redirectAfterLogin', to.fullPath);
                return '/login';
            }

            // if (from.path === '/login' || from.path === '/') {
            //     const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
            //     if (redirectAfterLogin && redirectAfterLogin !== '/login' && redirectAfterLogin !== '/') {
            //         localStorage.removeItem('redirectAfterLogin');
            //         return redirectAfterLogin;
            //     }
            // }
            // return true;
            if (from.path === '/login' || from.path === '/') {
                const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
                if (redirectAfterLogin && redirectAfterLogin !== '/login' && redirectAfterLogin !== '/') {
                    localStorage.removeItem('redirectAfterLogin');
                    return redirectAfterLogin;
                }

                if (to.path === '/dashboard') {
                    const isClient = localStorage.getItem('isClient') === 'true';
                    const isFournisseur = localStorage.getItem('isFournisseur') === 'true';

                    if (!isClient && isFournisseur) {
                        return '/dashboard-fournisseur';
                    }
                }
            }
            return true;
        }

        if (to.path === '/login') {
            await msalInstance
                .handleRedirectPromise()
                .then(() => {
                    store.commit(`authenticationState/${AUTHENTICATION.SET_SIGN_IN_AZURE_SUCCESSFUL}`, true);
                })
                .catch((error: string) => {
                    store.commit(`authenticationState/${AUTHENTICATION.SET_SIGN_IN_AZURE_SUCCESSFUL}`, false);
                    console.error(error);
                });
        }
        return true;
    });
}

async function isAuthenticated(): Promise<boolean> {
    const tokenPortail = localStorage.getItem('token_portail_partenaire');
    const activeAccount = msalInstance.getActiveAccount();

    let authenticated = false;

    //Vérifier qu'un compte MSAL est disponible avant d'appeler acquireTokenSilent
    if (!activeAccount) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts && accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        } else {
            // Aucun compte actif -> l'utilisateur n'est pas connecté. Ne pas appeler acquireTokenSilent.
            console.info('[Guards] Aucun compte MSAL actif, utilisateur non authentifié');
            return false;
        }
    }

    // On déclenche l'attente de chargement uniquement quand on va réellement tenter d'acquérir un token
    store.commit(`authenticationState/${AUTHENTICATION.SET_ACQUIRING_TOKEN}`, true);

    await msalInstance
        .acquireTokenSilent(loginRequest)
        .then(async (authResult: AuthenticationResult) => {
            if (!tokenPortail) {
                const data: AuthenticationParameters = { tokenAzure: authResult.idToken };
                await store.dispatch(AuthAction.POST_LOGIN, data);
            }
            authenticated = true;
        })
        .catch(async (error: any) => {
            console.info('[Guards] acquireTokenSilent KO');
            console.error(error);
        });

    console.info('[Guards] isAuthenticated return ' + authenticated);

    store.commit(`authenticationState/${AUTHENTICATION.SET_ACQUIRING_TOKEN}`, false);

    return authenticated;
}

function handleAzureError(authenticated: boolean, to: RouteLocationNormalized, from: RouteLocationNormalized) {
    if (!authenticated && to.hash.startsWith('#error')) {
        const error =
            StringUtils.parseHashRoutePartToObject(to.hash).error +
            ' ' +
            StringUtils.truncateString(StringUtils.parseHashRoutePartToObject(to.hash).error_description, 50);
        store.commit(AUTHENTICATION.SET_SIGN_IN_AZURE_ERROR, error);
    }

    if (!authenticated && !(from.path === '/' && to.path === '/dashboard' && to.hash)) {
        store.commit(`authenticationState/${AUTHENTICATION.SET_SIGN_IN_AZURE_SUCCESSFUL}`, false);
    }
}
